    
        <div class="mat-drawer-transition" *ngIf="isSelectorPanelOpened">
            <div class="mat-drawer-backdrop mat-drawer-shown custom-backdrop"></div>
        </div>
        <mat-drawer class="users-list-sidenav" position="end" mode="over" [opened]="isSelectorPanelOpened" disableClose="true" #usersSelectorPanel>
            <div class="panel-container">
    
                <div class="panel-header mb-16">
                    <div class="h-56 d-flex justify-content-between align-items-center">
                        <div>
                            <h6 class="mb-4">Users</h6>
                            <div class="mat-subtitle-2 text-hint">Note: {{ broadcastType === welcomeMessageParam ? userMessages.WELCOME_USER_SELECTOR_NOTE : userMessages.USER_SELECTOR_NOTE }}</div>
                        </div>
    
                        <div class="mb-2 d-flex justify-content-between align-items-center">
                            <button 
                                mat-flat-button 
                                class="mr-12" 
                                [color]="!selectedUsers?.length ? '' : 'accent'" 
                                [disabled]="!selectedUsers?.length" 
                                (click)="confirmSelectedUsers()"
                            >CONTINUE</button>
    
                            <button 
                                (click)="openConfirmPanel()"
                                [matTooltip]="'Selected Members'" 
                                [matTooltipPosition]="'below'" 
                                mat-icon-button 
                                class="mr-12"
                            >
                                <mat-icon 
                                    class="material-icons-outlined"
                                    [matBadge]="selectedUsers?.length" 
                                    matBadgeColor="warn"
                                >groups</mat-icon>
                            </button>
    
                            <button 
                                mat-icon-button 
                                (click)="cancelSelector()" 
                                [matTooltip]="'Close'"
                                [matTooltipPosition]="'below'" 
                            >
                                <mat-icon class="material-icons-outlined">close</mat-icon>
                            </button>
                        </div>
                    </div>
    
                    <mat-divider></mat-divider>
                </div>
    
                <div *ngIf="reqProgress; else panelContentTemp" class="favicon-spinner">
                    <mat-spinner [diameter]="50"></mat-spinner>
                </div>

                <ng-template #panelContentTemp>
                    <div class="panel-content">
                        <app-users-selector-list
                            #userSelectorListCompRef
                            [reqProgress]="reqProgress"
                            [usersList]="usersList"
                            [userSelectorData]="userSelectorData"
                            [userFilterLists]="userFilterLists"
                            [usersSelectorParams]="usersSelectorParams"
                            [initialNote]="panelNotes.tableInitialText || ''"
                            [broadcastType]="broadcastType"
                            [medicaidEnabled]="appProfileData?.currentOrganization?.medicaid_enabled ?? false"
                            (filterList)="fetchUsersList($event)"
                            (setUserSelectorData)="setUserSelectorData($event)"
                        ></app-users-selector-list>
                    </div>
                </ng-template>

            </div>

            <app-selector-confirm-panel 
                [data]="selectedUsers" 
                [viewKeys]="{ title: ['fname', 'lname'], subtitle: ['Programs.name'], subAlt: noProgramFilterValue.name }" 
                [noSelectedDataNote]="panelNotes.noSelectedNote || ''" 
                (toggleSelectedRows)="setUserSelectorData($event)"
                (clearAll)="clearAllLog()"
                #selectorConfirmPanelCompRef
                >
            </app-selector-confirm-panel>

        </mat-drawer>